import React, { useState } from "react";
import { Grid, Typography, Paper, Button, Checkbox, FormControlLabel, Tooltip } from '@mui/material';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import Box from "@mui/material/Box";
import { useAuth } from '../hooks/useAuth';

export default function PaypalZelle({ eventData, setSuccess, isGuest, eventTypeId }) {
    const { accessToken, signOut } = useAuth();
    const API_URL = process.env.REACT_APP_API_URL;
    const [paymentData, setPaymentData] = useState(eventData);
    const [paymentTypeSelected, setPaymentTypeSelected] = useState('');
    const [showZelleQR, setShowZelleQR] = useState(false);
    const zelleQRCodeUrl = "https://membership.cmdfw.org/images/2025/cmdfw_ZelleQR.jpg"; // Place your QR code image in public/images
    const [zelleAccepted, setZelleAccepted] = useState(false); // State to manage checkbox
    const zelleAmount = paymentData.transaction.itemPrice * paymentData.transaction.quantities + paymentData.transaction.donationAmount;
    console.log("Event data in Paypal comp before :", eventData, paymentData);

    const handleZelle = () => {
        setSuccess(true);
        console.log('Zelle Event data in payment comp : ', paymentData);
        sendToServer();
    }
    function zelleEnableHandler(e) {
        //setError(null); // Clear any existing errors
        setZelleAccepted(e.target.checked)
        if (!e.target.checked) {
            // reset payment type selection when user unchecks the Zelle accepted checkbox
            paymentData.transaction.paymentType = '';
            setPaymentTypeSelected('');
        }
    }
    function handlePaymentMethodChange(e) {
        const selectedPaymentType = e.target.value;
        // Update selected payment type local state
        setPaymentTypeSelected(selectedPaymentType);

        // Update paymentData immutably (avoid direct mutation)
        setPaymentData(prev => {
            const total = parseInt(zelleAmount, 10);
            return {
                ...prev,
                status: 'paid',
                transaction: {
                    ...prev.transaction,
                    paymentType: selectedPaymentType,
                    payerId: `${selectedPaymentType} Payment`,
                    totalAmount: total,
                },
            };
        });
    }
    async function sendToServer() {
        console.log("transaction payment data inside sendToServer :", paymentData);

        if (isGuest) {
            const guestPayload = {
                firstName: paymentData.parent.firstName,
                lastName: paymentData.parent.lastName,
                email: paymentData.parent.email,
                phone: paymentData.parent.mobileNumber,
                eventTypeId: eventTypeId || (paymentData.events && paymentData.events[0] && paymentData.events[0].eventTypeId),
                numTickets: paymentData.transaction.quantities || 1,
                customFields: null,
                transaction: {
                    itemPrice: paymentData.transaction.itemPrice || 0,
                    donationAmount: paymentData.transaction.donationAmount || 0,
                    totalAmount: paymentData.transaction.totalAmount,
                    paymentStatus: 'paid',
                    payerId: paymentData.transaction.payerId || paymentData.transaction.paymentType,
                    paymentType: paymentData.transaction.paymentType,
                },
            };
            try {
                const response = await fetch(`${API_URL}/guestRegistration`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(guestPayload),
                });
                if (!response.ok) {
                    const err = await response.json();
                    console.error('Guest registration error:', err);
                }
                return response.ok;
            } catch (error) {
                console.error('Guest registration failed:', error);
                return false;
            }
        }

        const maxRetries = 3;
        let attempt = 0;

        while (attempt < maxRetries) {
            try {
                const response = await fetch(`${API_URL}/events`, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        "x-cmdfw-jwt-token": `${accessToken}`,
                    },
                    body: JSON.stringify(paymentData),
                });
                if (response.ok) {
                    return true;
                }
                if (response.status === 403) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || 'OTP expired');
                } else {
                    const errorData = await response.json();
                    console.error('API Error:', errorData);
                    return false;
                }
            } catch (error) {
                console.error(`Attempt ${attempt + 1} failed:`, error);
                attempt++;
                if (attempt >= maxRetries) {
                    console.error('All retry attempts failed.');
                    return false;
                }
                console.log(`Retrying API call... (${attempt}/${maxRetries})`);
            }
        }
    }

    const initialOptions = {
        clientId: process.env.REACT_APP_PROD_CLIENT_ID,
        currency: "USD",
        intent: "capture",
        "disable-funding": "paylater"
    };

    const [errorMessage, setErrorMessage] = useState('')
    const [orderId, setOrderId] = useState(false)

    const createOrder = (data, actions) => {
        var itemArray = [];

        if (paymentData.transaction.quantities > 0) {
            itemArray[itemArray.length] = {
                name: paymentData.eventType,
                description: paymentData.eventType,
                unit_amount: {
                    currency_code: "USD",
                    value: "" + parseInt(paymentData.transaction.itemPrice * paymentData.transaction.quantities),
                },
                quantity: "1",
            }
        }
        console.log('items array donation:', paymentData.transaction.donationAmount);
        if (paymentData.transaction.donationAmount > 0) {
            itemArray[itemArray.length] = {
                name: "Donation Amount",
                description: "Donation item",
                unit_amount: {
                    currency_code: "USD",
                    value: paymentData.transaction.donationAmount,
                },
                quantity: "1",
            }
        }
        console.log('items array fee:', paymentData.feeEnabled);
        if (paymentData.feeEnabled > 0) {
            itemArray[itemArray.length] = {
                name: "Credit Card processing Fee Amount",
                description: "Credit Card Fee item",
                unit_amount: {
                    currency_code: "USD",
                    value: ((parseInt(paymentData.transaction.quantities) * paymentData.transaction.itemPrice + parseInt(paymentData.transaction.donationAmount)) * 0.03).toFixed(2),
                },
                quantity: "1",
            }
        }
        console.log('items array in create order 2:', itemArray, paymentData.transaction.totalAmount, paymentData.transaction.donationAmount);
        return actions.order.create({
            purchase_units: [
                {
                    description: paymentData.eventType,
                    amount: {
                        value: paymentData.transaction.totalAmount,
                        currency_code: "USD",
                        breakdown: {
                            item_total: {
                                value: paymentData.transaction.totalAmount,
                                currency_code: "USD",
                            }
                        }
                    },

                    items: itemArray, /**/
                },
            ],
            payer: {
                name: {
                    given_name: paymentData.parent.firstName, // First Name from the form
                    surname: paymentData.parent.lastName // Last Name from the form
                },
                email_address: paymentData.parent.email, //paymentData.parent.email,
                phone: {
                    phone_type: "MOBILE",  // Specify it's a mobile number
                    phone_number: {
                        national_number: paymentData.parent.mobileNumber  // Mobile number
                    }
                },
            }
        })
            .then((orderId) => {
                setOrderId(orderId)
                return orderId
            })
    }
    const onApprove = (data, actions) => {
        return actions.order.capture().then(function (details) {
            const { payer } = details
            console.log('Payer info : ', payer, paymentData.transaction.paymentStatus);
            setSuccess(true);
            paymentData.status = 'paid';
            paymentData.transaction.payerId = payer.payer_id;
            ///setpaymentData(paymentData);
            console.log('Payer info : ', payer);
            console.log('on Approve Event data in payment comp : ', paymentData);
            sendToServer();
        })
    }
    const onError = (data, actions) => {
        console.log('An error with Paypal approve Event data : ', paymentData, data, actions);
        setErrorMessage("An error occured with your payment")
    }
 
    return (
        <div>
            <Grid container direction="column" alignItems="left" >
                {
                    <Grid item>
                        <span>
                            <Box sx={{ width: '100%', maxWidth: 500 }}>
                                <Typography variant="h6" align="left" gutterBottom>
                                    <div><br /></div>
                                    <Paper style={{ padding: '16px', backgroundColor: '#dfe7e7', color: 'black', fontWeight: 'bolder' }} elevation={3}>
                                        <div><b>Payment Amount with Paypal/Card :</b> ${paymentData.transaction.totalAmount}</div>
                                        <div><b>Payment Amount with Zelle :</b> ${parseInt(zelleAmount)}</div>

                                    </Paper>
                                    <div><br /></div>
                                </Typography>
                            </Box>
                        </span>

                        <div><br /></div>


                        {/* Zelle Button */}                        
                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                            <Button
                                variant="contained"
                                color="primary"
                                sx={{
                                    width: 400,
                                    height: 48,
                                    borderRadius: 2,
                                    fontWeight: 'bold',
                                    fontSize: 18,
                                    background: '#6c3483',
                                    mb: 2,
                                    boxShadow: 2,
                                    '&:hover': {
                                        background: '#512e5f'
                                    }
                                }}
                                onClick={() => setShowZelleQR((prev) => !prev)}
                            >

                                Pay with Zelle/Cash/Check
                            </Button>
                        </Grid>

                        {/* Zelle QR Code */}

                        {showZelleQR && (
                            <Grid item xs={12} sm={8}> {/* changed from xs={8} to xs={12} sm={8} for mobile */}
                                <Paper elevation={3} sx={{ p: 2, mb: 2, textAlign: 'left' }}>
                                    <Typography variant="h5" >
                                        <div>Open your banking app</div>
                                        Send Zelle payment of <b>${parseInt(zelleAmount)}</b> to: <b>finance@cmdfw.org</b>
                                        <div><br /></div>
                                        <div>or scan the QR Code below</div>
                                    </Typography>

                                    {/* responsive QR image */}
                                    <Box
                                        component="img"
                                        src={zelleQRCodeUrl}
                                        alt="Zelle QR Code"
                                        sx={{
                                            width: { xs: '100%', sm: 320, md: 400 }, // full width on xs, capped on larger screens
                                            maxWidth: 400,
                                            height: 'auto',
                                            display: 'block',
                                            mx: 'auto',
                                            mb: 2,
                                        }}
                                    />

                                    <Grid container direction="row" spacing={5}>
                                        <Grid item>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={zelleAccepted}
                                                        onChange={zelleEnableHandler}
                                                        name="zelleAccepted"
                                                        color="primary"
                                                    />
                                                }
                                                label="I paid the amount via Zelle, Cash or Check."
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid item>
                                        {zelleAccepted && (
                                            <FormControl variant="standard" sx={{ m: 1, minWidth: 200 }} size="small">
                                                <InputLabel id="demo-simple-select-standard-label">Payment Method</InputLabel>
                                                <Select
                                                    id="standard"
                                                    required
                                                    name="paymentMethod"
                                                    label="Payment Method"
                                                    value={paymentData.transaction.paymentType || ''}
                                                    onChange={handlePaymentMethodChange}
                                                >
                                                    <MenuItem value="Zelle">Zelle</MenuItem>
                                                    <MenuItem value="Check">Check</MenuItem>
                                                    <MenuItem value="Cash">Cash</MenuItem>
                                                </Select>
                                                
                                            </FormControl>
                                        )}
                                        <Tooltip title={!paymentTypeSelected ? "Please accept the rules and policies" : ""}>

                                            <span>
                                                <Button type="submit" variant="contained" sx={{ mt: 3, mb: 2 }} disabled={!paymentTypeSelected} onClick={() => handleZelle()}>Submit</Button>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                </Paper>

                            </Grid>
                        )}
                        <PayPalScriptProvider options={initialOptions}>
                            <PayPalButtons style={{ layout: "vertical", label: "pay" }}
                                createOrder={createOrder}
                                onApprove={onApprove}
                                onClick={() => setShowZelleQR(false)}
                            />
                        </PayPalScriptProvider>
                    </Grid>}
                <Grid container direction="row" spacing={5}>
                    <Grid item>
                        <Typography variant="body2" align="center" gutterBottom>
                            NOTE: if you don't see PayPal buttons, please use Chrome browser (or) Laptop. If you have any questions, contact us at <a href="mailto:membership@cmdfw.org">membership@cmdfw.org</a>
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </div >
    );
}